/*
 * @Author: jiangzhengjie
 * @Date: 2023-09-02 17:49:04
 * @LastEditors: jiangzhengjie jiangzhengjie@didiglobal.com
 * @LastEditTime: 2023-09-06 16:18:16
 * @FilePath: /train-service/src/components/controllable-drawer-buttom.mpx
 * @Description: 样式可控弹窗 标题默认居中字体16px平方regular#222色号 离顶部20px 
    关闭按钮宽高24px，绝对定位右上各16px
 * 不想写bug  ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ
 */
<template minapp='mpx' xlang='wxml'>
  <es-popup
    show="{{show}}"
    position="bottom"
    class="custom-class"
    customStyle="{{containerStyle}}"
    bind:close="close"
  >
    <view class="drawer-container" wx:style="{{customStyle}}">
      <view wx:if="{{useSimpleHeader}}" class="header" wx:style="{{headerStyle}}">
        {{ title }}
      </view>
      <view wx:else class="header" wx:style="{{headerStyle}}">
         <slot name="left" />
      </view>
      <slot />
      <view         
        wx:if="{{showCloseBtn}}"
        class="close-icon"
        wx:style="{{iconStyle}}"
        bindtap="close"
        >
        <spring-icon wx:if="{{useDefaultIcon}}" size="{{transferIconSize}}" name="close" />
        <slot wx:else name="close-icon" />
      </view>
    </view>
  </es-popup>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    externalClasses: ['custom-class'],
    props: {
      show: {
        type: Boolean,
        value: false,
      },
      title: {
        type: String,
        value: '',
      },
      iconSize: {
        type: Number,
        value: 24,
      },
      iconStyle: {
        type: Object,
        value: () => {},
      },
      containerStyle: {
        type: Object,
        value: () => {},
      },
      customStyle: {
        type: Object,
        value: () => {},
      },
      headerStyle: {
        type: Object,
        value: () => {},
      },
      showCloseBtn: {
        type: Boolean,
        value: true
      },
      // 默认简单标题 反之传slot
      useSimpleHeader: {
        type: Boolean,
        value: true
      },
      useDefaultIcon: {
        type: Boolean,
        value: true
      }
    },
    data() {
      return {}
    },
    computed: {
      transferIconSize() {
        return this.iconSize * 2
      }
    },
    methods: {
      close() {
        this.$trigger('close')
      },
    },
  })
</script>

<style lang="stylus" scoped>
  .drawer-container
    background #ffffff
    border-radius 10px 10px 0 0
    display flex
    flex-direction column
    position relative
    box-sizing border-box
    .header
      width 100%
      display flex
      font-family PingFangSC-Regular
      justify-content center
      font-size 16px
      line-height 16px
      padding-top 20px
      color #222
    .close-icon
      position absolute
      color #333
      top 16px
      right 16px
      z-index 10
</style>
<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'es-popup': '@didi/es-mpx-ui/lib/popup',
      'spring-icon': '@didi/spring-icon'
    },
  }
</script>
